import DBOperationsComb from "src/utils/dbOperationsComb";
import Constants from "src/utils/constants";
import Exception from "src/utils/exception";

async function getShippingReqFormsList(config) {
  try {
    return await DBOperationsComb.fetchData(
      {
        tableName: Constants.enums.TABLES_NAME_ENUM.SHIPPING_REQ_LIST_TABLE,
        fetchDeleted: config.fetchDeleted,
        searchTxt: config.searchTxt,
        sortField: config.sortField, // for sorting fields ex: sortField: ["group_order", "mandatory", "item_order"],
        sortOrder: config.sortOrder, // for sort order     ex: sortOrder: [1, -1, 1],
        page: config.page,
        rows: config.rows,
        fetchAll: config.fetchAll,
        queryParams: config.queryParams
      },
      false
    );
  } catch (error) {
    Exception.catchException(error);
    return {
      error
    };
  }
}

async function getShippingReqFormById(id) {
  try {
    const _res = await DBOperationsComb.getData(
      Constants.enums.TABLES_NAME_ENUM.SHIPPING_REQ_LIST_TABLE,
      id,
      false
    );
    if (_res.error) throw _res.error;
    return _res;
  } catch (error) {
    Exception.catchException(error);
    return { error };
  }
}

async function createShippingReq(data) {
  try {
    return await DBOperationsComb.insertData(
      Constants.enums.TABLES_NAME_ENUM.SHIPPING_REQ_LIST_TABLE,
      data,
      false,
      { attribution: false }
    );
  } catch (error) {
    Exception.catchException(error);
    return { error };
  }
}

async function updateShippingReq(data) {
  try {
    return await DBOperationsComb.updateData(
      Constants.enums.TABLES_NAME_ENUM.SHIPPING_REQ_LIST_TABLE,
      data,
      false,
      { attribution: false }
    );
  } catch (error) {
    Exception.catchException(error);
    return { error };
  }
}

export default {
  getShippingReqFormsList,
  getShippingReqFormById,
  createShippingReq,
  updateShippingReq
};
